import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { UserDataProvider } from "../../data-provider/user.dp";
import { Campaign } from "../../models/campaign.model";
import { DialogUtils } from "../../helper/dialog.helper";
import { PermissionCheck } from "../../shared/permission";
import { ScreenUtils } from "../../helper/screen.helper";
import { Utils } from "../../helper/utils.helper";

let LimitExceededComponent = {
    selector: "vcLimitExceeded",
    templateUrl: "/angular/components/limit/limit-exceeded.component.html",
    bindings: {
        imageName: "=?",
        type: "=",
        inDialog: "=?",
        limit: "=",
        otherAction: "&?",
        reloadOnSuccess: "=?",
        canPurchaseLicenses: "=?",
    },
    controller: class LimitExceededController {
        // * bindings for typescript compiler *
        public imageName?: any;
        public type?: any;
        public inDialog?: any;
        public limit?: any;
        public otherAction?: any;
        public reloadOnSuccess?: any;
        public canPurchaseLicenses?: any;
        // ************************************

        private $scope: any;
        private $window: any;
        private utils: Utils;
        private dialog: DialogUtils;
        private userDataProvider: UserDataProvider;
        private permissionProvider: PermissionCheck;

        public isLeaderView: boolean;
        public isOrgCampaign: boolean;
        public activeCampaign: Campaign;
        public screen: ScreenUtils;

        constructor(
            $scope: any,
            $window: any,
            Utils: Utils,
            ScreenUtils: ScreenUtils,
            DialogUtils: DialogUtils,
            PermissionCheck: PermissionCheck,
            CampaignDataProvider: CampaignDataProvider,
            UserDataProvider: UserDataProvider,
            __app_type: string
        ) {
            this.utils = Utils;
            this.$scope = $scope;
            this.screen = ScreenUtils;
            this.$window = $window;
            this.isLeaderView = __app_type == "LEADER";
            this.dialog = DialogUtils;
            this.permissionProvider = PermissionCheck;
            this.userDataProvider = UserDataProvider;
            this.activeCampaign = CampaignDataProvider.getActiveCampaign();
            this.isOrgCampaign =
                __app_type == "USER" &&
                this.activeCampaign.isOrganisationCampaign();
        }

        $onInit() {
            this.imageName = this.imageName ?? "no-surveys";
            if (angular.isUndefined(this.reloadOnSuccess))
                this.reloadOnSuccess = true;
            if (angular.isUndefined(this.inDialog)) {
                this.inDialog = true;
            }
        }

        dismiss(): void {
            this.dialog.hide();
        }

        openUpgradePlanDialog(conversionType: string, ev: object): void {
            this.dialog
                .show({
                    component: "vc-upgrade-plan-dialog",
                    targetEvent: ev,
                    scope: this.$scope,
                    locals: {
                        conversionType: conversionType,
                        reloadOnSuccess: this.reloadOnSuccess,
                    },
                    fullscreen: true,
                    forceFullscreen: true,
                    size: "xx-large",
                    style: "background: #f6f6f6",
                })
                .then(() => {
                    if (this.reloadOnSuccess) {
                        this.$window.reload();
                    }
                });
        }

        hasPurchaseAbility(): boolean {
            return (
                this.permissionProvider.hasPermission("CHANGE_PLAN") &&
                !this.isOrgCampaign &&
                !this.permissionProvider.hasStripeSubscription
            );
        }

        openChooseQuantityDialog(): void {
            this.dialog
                .show({
                    component: "vc-seats-settings-dialog",
                    size: "large",
                    scope: this.$scope,
                    locals: {},
                })
                .then((numSeats: any) => {
                    this.openPurchaseSeatsDialog(numSeats);
                });
        }

        openPurchaseSeatsDialog(numSeats: any): void {
            this.dialog
                .show({
                    component: "purchase-seats-dialog",
                    size: "large",
                    scope: this.$scope,
                    locals: {
                        numSeats: numSeats,
                    },
                })
                .then(() => {
                    this.userDataProvider.resetUsersCount();
                });
        }
    },
};

angular
    .module("limit", [])
    .component(LimitExceededComponent.selector, LimitExceededComponent);
